import { v2 } from 'cloudinary';
import * as transformations from './transformations.json';

export const getImageUrl = (image, options) => {
  const publicId = image.replace('cd_', '');
  const mergedOptions = {
    cloud_name: 'italist',
    cname: 'cdn-images.italist.com',
    fetch_format: 'auto',
    format: 'jpg',
    private_cdn: true,
    secure: true,
    secure_distribution: 'cdn-images.italist.com',
    ...options,
  };
  if (!('transformation' in mergedOptions) && !('dpr' in mergedOptions)) {
    mergedOptions.dpr = 2;
  }
  return v2.url(publicId, mergedOptions);
};

export const getCloudProductImage = (image, presetName) => {
  if (image.indexOf('cd_') === 0) {
    const publicId = image.replace('cd_', '');
    const transformation = transformations.product[presetName];
    const prefix = process.env.CLOUDINARY_TRANSFORMATION_PREFIX || '';
    return `https://cdn-images.italist.com/image/upload/t_${prefix}${transformation}/${publicId}.jpg`;
  }
  return '';
};

export const getAllTransformations = (
  image,
): {
  cart: string;
  medium: string;
  micro: string;
  mini: string;
  mini_mobile: string;
  thumb: string;
  zoom: string;
} => {
  const urls = {
    cart: '',
    medium: '',
    micro: '',
    mini: '',
    mini_mobile: '',
    thumb: '',
    zoom: '',
  };
  Object.keys(transformations.product).forEach(key => {
    urls[key] = getCloudProductImage(image, key);
  });
  return urls;
};
